

import PropTypes from "prop-types";

export const OfferItem = ( {image, titleheader, checkAni, animation}) => {
    return (
        <div className={`w-[300px] mothaibaysai:w-[250px]  p-[20px] group hover:bg-[#2B1C50]  hover:rounded-[10px] ${checkAni ? "animate-zoomIn0.3" : ""} `} style={{animationDelay: animation}}>
            <div className="flex flex-col   gap-[32px] items-center">
                <div className="w-[80px] h-[80px] bg-white shadow-border-home rounded-[50px]">
                    <img className="p-[25px]" src={image} />
                </div>
                <p className="text-4 group-hover:text-[#EFF0FF] text-[--color-title] font-bold">{titleheader}</p>

            </div>
    </div>
    )
}

OfferItem.propTypes = {
    image: PropTypes.string,
    titleheader: PropTypes.string,
    checkAni: PropTypes.bool,
    animation:  PropTypes.string,
    
  };